import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { copy } from '../copy';
interface NewProjectModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string, description: string) => void;
}
export function NewProjectModal({
  isOpen,
  onClose,
  onSave
}: NewProjectModalProps) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      onSave(name, description);
      setName('');
      setDescription('');
    }
  };
  return <AnimatePresence data-id="element-243">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-244">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-slate-900/40 dark:bg-black/60 backdrop-blur-sm" data-id="element-245" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-lg overflow-hidden rounded-3xl border border-slate-200 dark:border-[#333] bg-white dark:bg-[#1a1a1a] shadow-2xl" data-id="element-246">
            <div className="flex items-center justify-between border-b border-slate-100 dark:border-[#262626] p-6" data-id="element-247">
              <h2 className="text-xl font-semibold text-slate-900 dark:text-white" data-id="element-248">
                {copy.newCaseModal.title}
              </h2>
              <button onClick={onClose} className="rounded-full p-2 text-slate-400 hover:bg-slate-100 dark:hover:bg-white/5 dark:text-[#555] dark:hover:text-[#a3a3a3] transition-colors" data-id="element-249">
                <X size={20} data-id="element-250" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-6 space-y-6" data-id="element-251">
              <div className="space-y-2" data-id="element-252">
                <label className="text-sm font-medium text-slate-700 dark:text-[#a3a3a3]" data-id="element-253">
                  {copy.newCaseModal.nameLabel}
                </label>
                <input autoFocus type="text" value={name} onChange={e => setName(e.target.value)} placeholder={copy.newCaseModal.namePlaceholder} className="w-full rounded-xl border border-slate-200 dark:border-[#333] bg-slate-50 dark:bg-[#222] px-4 py-3 text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-slate-200 dark:focus:ring-slate-800 transition-all placeholder:text-slate-400 dark:placeholder:text-[#555]" data-id="element-254" />
              </div>

              <div className="space-y-2" data-id="element-255">
                <label className="text-sm font-medium text-slate-700 dark:text-[#a3a3a3]" data-id="element-256">
                  {copy.newCaseModal.summaryLabel}
                </label>
                <textarea value={description} onChange={e => setDescription(e.target.value)} placeholder={copy.newCaseModal.summaryPlaceholder} rows={3} className="w-full rounded-xl border border-slate-200 dark:border-[#333] bg-slate-50 dark:bg-[#222] px-4 py-3 text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-slate-200 dark:focus:ring-slate-800 transition-all placeholder:text-slate-400 dark:placeholder:text-[#555] resize-none" data-id="element-257" />
              </div>

              <div className="flex gap-3 pt-2" data-id="element-258">
                <button type="button" onClick={onClose} className="flex-1 rounded-xl border border-slate-200 dark:border-[#333] px-4 py-3 text-sm font-medium text-slate-600 dark:text-[#a3a3a3] hover:bg-slate-50 dark:hover:bg-white/5 transition-colors" data-id="element-259">
                  {copy.newCaseModal.cancel}
                </button>
                <button type="submit" disabled={!name.trim()} className="flex-1 rounded-xl bg-slate-900 dark:bg-white px-4 py-3 text-sm font-medium text-white dark:text-slate-900 hover:bg-slate-800 dark:hover:bg-slate-100 disabled:opacity-50 transition-all shadow-sm" data-id="element-260">
                  {copy.newCaseModal.create}
                </button>
              </div>
            </form>
          </motion.div>
        </div>}
    </AnimatePresence>;
}